import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import CategoryCard from '../components/product/CategoryCard';
import SEO from '../components/common/SEO';
import { useApp } from '../context/AppContext';

const CategoriesPage = () => {
  const { categories } = useApp();

  return (
    <Layout title="Categories" showBack>
      {/* SEO for Categories */}
      <SEO 
        title="Browse Categories"
        description="Browse all categories on Minted - Electronics, Clothing, Toys, Furniture, Baby & Kids, Sports, and more. Find preloved items near you."
        url="/categories"
        breadcrumbs={[{ name: 'Categories', url: '/categories' }]}
      />
      <div className="p-4">
        <div className="grid grid-cols-2 gap-3">
          {categories.map((category) => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default CategoriesPage;